import { styled } from 'styled-components';

const AI_TAG_TEXT_COLOR = '#ffc0e0';

export const TagWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing(3)}px;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing()}px;
`;

export const TagText = styled.span`
  font-size: ${({ theme }) => theme.font.size.sm}rem;
  color: ${AI_TAG_TEXT_COLOR};
  sup {
    font-size: 0.6em;
    vertical-align: super;
  }
`;
